import * as React from "react";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Typography, Alert, Button, Paper } from "@mui/material";
import Divider from "@mui/material/Divider";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import SubtitlesListQuery from "./SubtitlesListQuery";
import SubtitlesList from "./SubtitlesList";
import { findSubtitlesApi } from "../../../../../services/subtitlesApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../../../utils/utilsFunctions";
const SEARCH_URL = `${process.env.REACT_APP_SITEURL}/sub`;

export default function SearchSubtitles() {
  const [fetchedSubtitlesList, setFetchedSubtitlesList] = React.useState({
    docs: [],
  });
  const [querySubtitlesListData, setQuerySubtitlesListData] = React.useState(
    {}
  );
  const [pageAndPerPage, setPageAndPerPage] = React.useState({
    page: 1,
    perPage: 10,
    totalPages: 0,
    hasNextPage: false,
    hasPrevPage: false,
    totalDocs: 0,
  });
  const [controlAlert, setControlAlert] = React.useState({
    open: true,
    message: "لطفا یکی از گزینه های بالا را انتخاب کنید و روی مشاهده کلیک کنید",
    severity: "warning",
    SkeletonDisplay: "none",
  });

  // کنترل شماره صفحه و تعداد در هر صفحه
  const setNumberPageAndPerPage = (type, number) => {
    let newValues = {};
    if (type == "page") newValues["page"] = number;
    if (type == "perPage") {
      newValues["perPage"] = number;
      newValues["page"] = 1;
    }
    const PageAndPerPageValue = { ...pageAndPerPage, ...newValues };
    setPageAndPerPage(PageAndPerPageValue);
    getSubtitlesListFromBack(
      "findSubtitlesApi",
      querySubtitlesListData,
      PageAndPerPageValue
    );
  };

  const getSubtitlesListFromBack = async (request, data, paginateData = {}) => {
    try {
      setControlAlert({
        open: true,
        message: "درخواست ارسال شد",
        severity: "warning",
        SkeletonDisplay: "Block",
      });
      setFetchedSubtitlesList({ docs: [] });
      let paginate = { ...pageAndPerPage, ...paginateData };
      if (request == "findSubtitlesApi") {
        let response = await findSubtitlesApi(data, paginate);
        const resData = checkResponseData(response);
        // console.log("amir", response);
        if (resData["success"]) {
          setFetchedSubtitlesList(resData["data"]);
          setControlAlert({
            open: true,
            message: "جواب آمد",
            severity: "warning",
            SkeletonDisplay: "none",
          });
          const { totalPages, hasNextPage, hasPrevPage, page, totalDocs } =
            resData["data"];
          const newValues = {
            totalPages,
            hasNextPage,
            hasPrevPage,
            page,
            totalDocs,
          };
          setPageAndPerPage({
            ...pageAndPerPage,
            ...paginateData,
            ...newValues,
          });
        } else {
          setControlAlert({
            open: true,
            message: "مشکلی پیش آمده است",
            severity: "warning",
            SkeletonDisplay: "none",
          });
        }
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      customToastify("error", errData["titles"] || errData["message"]);
      console.error(error);
    }
  };

  return (
    <Grid container sx={{ textAlign: "justify", height: "100vh" }}>
      <Paper sx={{ textAlign: "center", width: "100%", px: 1, pt: 5 }}>

        <a href={SEARCH_URL} target="_blank">
          <Button
            variant="contained"
            color="info" >جستجوی زیرنویس
          </Button>
        </a>

      </Paper>
    </Grid>
  );
}
